// removed by extract-text-webpack-plugin
module.exports = {"InformationFormsContainer":"_1fzzIZOCFOEpZp3zVxMJkF","InformationFormsWrapper":"_2kx219ykXlTS3g7lpzImpq","FormStyle":"_377CWxYyN6DDU6BhK66Tmb"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Forms/SlideInput/style.css
// module id = 1405
// module chunks = 0